import { formatDistanceToNow } from 'date-fns'
import { es } from 'date-fns/locale'

/**
 * Formats a number as a currency string in EUR (€)
 * @param amount - The amount to format
 * @returns A formatted string with the amount in EUR
 */
export const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    }).format(amount)
}

/**
 * Converts a Firebase Timestamp or ISO string to a Date object
 * @param createdAt - The creation date as Timestamp or ISO string
 * @returns A Date object or null if invalid
 */
const convertToDate = (createdAt?: { seconds: number; nanoseconds?: number } | string): Date | null => {
    if (!createdAt) return null

    if (typeof createdAt === 'string') {
        return new Date(createdAt)
    }

    if (typeof createdAt === 'object' && 'seconds' in createdAt) {
        return new Date(createdAt.seconds * 1000)
    }

    return null
}

/**
 * Formats the time elapsed since a given date in a human-readable way
 * @param createdAt - The creation date as Timestamp or ISO string
 * @returns A formatted string like "2 días" or null if date is invalid
 */
export const formatTimeAgo = (createdAt?: { seconds: number; nanoseconds?: number } | string): string | null => {
    const date = convertToDate(createdAt)
    if (!date || isNaN(date.getTime())) return null

    return formatDistanceToNow(date, {
        addSuffix: false,
        locale: es,
    })
}
